<template>
  <div class="Overview row">
    <div class="col-md-6">
      <Panel>
        <template slot="header">
          <h2>Players</h2>
        </template>
        <template slot="body">
          <Table class="Overview">
            <Row header>
              <Cell>Colour</Cell>
              <Cell class="text-left">Player</Cell>
              <Cell>APM</Cell>
              <Cell>Stay Time</Cell>
            </Row>

              <Row
                v-for="(player, index) in replay.getPlayers ()"
                :class="{
                  'Table-boundary' : isTeamTransition (index) === 0,
                  'Table-noborder' : isTeamTransition (index) !== 0
                }"
              >
                <Cell>
                  <Block
                    :colour="player.colour"
                  ></Block>
                </Cell>

                <Cell class="text-left"><Clan></Clan> <BattleTag :tag="player.name"></BattleTag></Cell>

                <Cell>
                  {{ player.apm }}

                  <Bar :fill="relative ('apm', replayPlayer (player), replay.data.game.players)"
                        width="80px">
                  </Bar>
                </Cell>
                <Cell>
                  <RadialProgress :fill="player.stayPercent">
                  </RadialProgress>
                </Cell>
              </Row>
          </Table>
        </template>
      </Panel>
    </div>

    <div class="col-md-6">
      <Panel>
        <template slot="header">
          <h2>Game Details</h2>
        </template>
        <template slot="body">
          <dl class="row">
            <dt class="col-6">Game Version</dt>
            <dd class="col-6">1.{{ replay.data.header.majorVersion - 10000 }}.{{ replay.data.header.buildVersion }}</dd>

            <dt class="col-6">Length</dt>
            <dd class="col-6">{{ time (replay.data.header.length) }}</dd>

            <dt class="col-6">Host</dt>
            <dd class="col-6">{{ replay.data.game.host }}</dd>

            <dt class="col-6">Uploader</dt>
            <dd class="col-6">{{ replay.uploads [0].saver }}</dd>

            <dt class="col-6">Played</dt>
            <dd class="col-6">{{ timestamp (replay.playedOn) }}</dd>

            <dt class="col-6">Map File</dt>
            <dd class="col-6 text-truncate" v-tooltip="{ content: replay.data.game.path, classes: [ 'tooltip', 'tooltip-nowrap' ] }">{{ replay.data.game.map }}</dd>

            <!-- <dt class="col-6">Speed</dt>
            <dd class="col-6">{{ lang (`speed.${replay.data.game.speed}`) }}</dd> -->

            <dt class="col-6">Visibility</dt>
            <dd class="col-6">{{ lang (`visibility.${replay.data.game.visibility}`) }}</dd>

            <dt class="col-6">Observers</dt>
            <dd class="col-6">{{ lang (`observers.${replay.data.game.observers}`) }}</dd>

            <!-- <dt class="col-6">W3MMD</dt>
            <dd class="col-6">{{ lang (!! (replay.flags & CST.REPLAY_HAS_W3MMD)) }}</dd> -->

            <!-- <dt class="col-6">Ratable</dt>
            <dd class="col-6">{{ lang (!! (replay.flags & CST.REPLAY_RATED)) }}</dd> -->

            <dt class="col-6">Ladder</dt>
            <dd class="col-6">{{ lang (!! (replay.flags & CST.REPLAY_LADDER)) }}</dd>

            <dt class="col-6">Single Player</dt>
            <dd class="col-6">{{ lang (!! (replay.flags & CST.REPLAY_LOCAL)) }}</dd>

            <!-- <dt class="col-6">Private</dt>
            <dd class="col-6">{{ lang (!replay.data.game.private) }}</dd> -->
            <!-- <dt class="col-6">Teams Together</dt>
            <dd class="col-6">{{ lang (replay.data.game.teamsTogether) }}</dd>-->

            <!-- <dt class="col-6">Teams Locked</dt>
            <dd class="col-6">{{ lang (replay.data.game.lockedTeams) }}</dd> -->

            <!-- <dt class="col-6">Full Share</dt>
            <dd class="col-6">{{ lang (replay.data.game.fullShare) }}</dd> -->

            <!-- <dt class="col-6">Random Heroes</dt>
            <dd class="col-6">{{ lang (replay.data.game.randomHero) }}</dd>

            <dt class="col-6">Random Races</dt>
            <dd class="col-6">{{ lang (replay.data.game.randomRaces) }}</dd> -->

            <dt class="col-6">Checksum</dt>
            <dd class="col-6">{{ hex (replay.data.header.checksum) }}</dd>

            <template v-if="replay.data.game.sha1">
              <dt class="col-6">SHA1</dt>
              <dd class="col-6">{{ hex (replay.data.game.sha1) }}</dd>
            </template>
          </dl>
        </template>
      </Panel>
    </div>
    <div class="col-md-12" v-if="replay.length > 60 * 10">
      <Panel class="Overview-apm">
        <template slot="header">
          <h2>APM</h2>
        </template>
        <template slot="body">
          <LineChart :series="replay.getApmSeries ()"
                     :curve="'curveCatmullRom'"
                     :autoScale="false"
                     :labels="{
                        x: 'Game Time',
                        y: 'Actions' ,
                        uX: 'Min',
                        uY: 'APM'
                      }"
          ></LineChart>
        </template>
      </Panel>
    </div>
  </div>
</template>

<script>
  import { Table, Row, Cell } from '@/legacy/components/widgets/Table.js';
  import Clan from '@/legacy/components/widgets/Clan';
  import RadialProgress from '@/legacy/components/widgets/RadialProgress';
  import Bar from '@/legacy/components/widgets/Bar';
  import Icon from '@/legacy/components/widgets/Icon';
  import Panel from '@/legacy/components/widgets/Panel';
  import Block from '@/legacy/components/widgets/Block';
  import Delta from '@/legacy/components/widgets/Delta';
  import BattleTag from '@/legacy/components/widgets/BattleTag';
  import LineChart from '@/legacy/components/widgets/LineChart';
  import { time, isTransition, relative, ordinal, interpolateColour, timestamp } from '@/legacy/lib//util';
  import { rgba, colourId, hex } from '@/legacy/lib//template';
  import { round } from '@/legacy/lib//math';
  import { resolve } from '@/legacy/router';
  import { lang } from '@/legacy/lib//lang';
  import CST from '@/legacy/lib//Constants';

  export default {
    props: {
      replay: {
        type: Object
      }
    },

    data: () => {
      return {
        CST
      };
    },

    components: {
      Table,
      Row,
      Cell,
      Clan,
      RadialProgress,
      Bar,
      Icon,
      Panel,
      Block,
      Delta,
      LineChart,
      BattleTag
    },

    methods: {
      time,
      rgba,
      relative,
      ordinal,
      resolve,
      hex,
      lang,
      timestamp,

      isTeamTransition (current) {
        return isTransition (this.replay.data.game.players, 'team', current);
      },

      placementBackground (placement) {
        return interpolateColour (
          (placement - 1) / (this.maxPlacement - 1)  * 100,
          null,
          null,
          true,
          0.08
        )
      },

      gamePlayer (replayPlayer) {
        if (! (this.game.teams instanceof Array)) {
          return {};
        }

        for (let team of this.game.teams) {
          for (let player of team.players) {
            if (player.name === replayPlayer.name) {
              return player;
            }
          }
        }

        return {};
      },

      gamePlayers ()
      {
        let players = [];

        for (let team of this.game.teams) {
          players = players.concat (team.players);
        }

        return players;
      },

      replayPlayer (gamePlayer) {
        for (let player of this.replay.getPlayers ()) {
          if (player.name === gamePlayer.name) {
            return player;
          }
        }

        return {};
      }
    },

    computed: {
      bestKills () {
        return this.replay.getBestPlayerBy ('variables.kills');
      },

      bestScore () {
        return this.replay.getBestPlayerBy ('variables.score');
      },

      bestApm () {
        return this.replay.getBestPlayerBy ('apm');
      },

      mvp () {
        let mvp   = null,
            ratio = 0;

        for (let player of this.replay.getPlayers ()) {
          player = this.gamePlayer (player);

          if (!player.rating) {
            continue;
          }

          let score = player.score;

          if (!score) {
            continue;
          }

          let test = score / player.rating;

          if (test > ratio) {
            ratio = test;

            mvp = player;
            mvp.ratio = round (ratio, 1);
          }
        }

        return mvp;
      },

      maxPlacement () {
        let placement = 1;

        for (let team of this.game.teams) {
          placement = Math.max (placement, team.placement);
        }

        return placement;
      }
    }
  };
</script>

<style lang="scss">
  .Overview {
    .Block {
      margin-top: 5px;
    }

    // .Separator {
    //   border-top-color: $w3s-grey-light;
    // }

    .Panel {
      margin: 15px 0 !important;
    }

    &-overall {
      .Panel {
        position: relative;

        img {
          position: absolute;
          left: 15px;
          top: 15px;
          width: 60px;
          height: 60px;
          width: auto;
        }
      }
    }

    &-placement {
      position: absolute;
      left: 15px;
      top: 10px;
    }

    &-apm {
      height: 640px;
    }
  }
</style>